<h2>{{ParameterName}}</h2>
<div class="row mb-0 w-size-250">
    <div class="col-4">Min:</div>
    <div class="col-8">{{Min}}</div>
    <div class="col-4">Max:</div>
    <div class="col-8">{{Max}}</div>
    <div class="col-4">Ideal:</div>
    <div class="col-8">{{Ideal}}</div>
</div>
<button type="button" class="btn btn-primary pull-right" (click)="Close()">Ok</button>